import React, {useEffect,useState} from "react";
import {$} from "../../../../../vendor";
import {useSelector, clientDocsActions, s3Actions} from "inbooma-api";
import {in_array} from "../../../../utils/Helper";
import {Biscuit} from "../../../../utils";
import {getApiHost} from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";

const ClientDocsList = (props) => {
    const { clientDocs, dispatch, filter, setFilter, sort, setSort, _key, setKey, params, rbac, language, Biscuit, showNotification,t , moment } = props;

    const _deleteClientDoc = useSelector(state => state["client_docs_data"].deleteClientDoc);
    const [deleteClientDocPending, setDeleteClientDocPending] = useState(null);
    const _publishDoc = useSelector(state => state["client_docs_data"].publishDoc);
    const [publishDocPending, setPublishDocPending] = useState(null);
    const [localClientDocs, setLocalClientDocs] = useState(clientDocs);
    const _getDocument = useSelector(state => state.s3_data.getDocumentS3);
    const [getDocumentPending, setGetDocumentPending] = useState(false);

    useEffect(() => {
        if(deleteClientDocPending === null || _deleteClientDoc.success === ''){
            return;
        }
        if(_deleteClientDoc.success !== true){
            showNotification('warning',null,_deleteClientDoc.data.message);
        } else {
            let clone = [...localClientDocs];
            clone.splice(deleteClientDocPending,1);
            setLocalClientDocs(clone);
        }
        setDeleteClientDocPending(null);
    }, [_deleteClientDoc]);

    useEffect(() =>{
        if(_key !== null){
            let selector = '[key='+_key+']';
            if ($(selector).length >= 1) {
                $('html,body').scrollTop($(selector).offset().top - 10)
            }
        }
    },[]) ;

    useEffect(() => {
        if(_getDocument.success === '' || !getDocumentPending){
            return;
        }
        if(_getDocument.success === true){
            const blob = new Blob([_getDocument.data], { type: _getDocument.data.type });
            FileSaver.saveAs(blob, getDocumentPending.replace(/_/gi, ' '));
        } else {
            alert('Could not download: ' + _getDocument.data);
        }
        setGetDocumentPending(false);
    }, [_getDocument]);

    useEffect(() => {
        if(_publishDoc.success === '' || !publishDocPending){
            return;
        }
        if(_publishDoc.success === true){

        } else {
            alert('Could not download: ' + _getDocument.data);
        }
        setPublishDocPending(false);
    }, [_publishDoc])

    const deleteClientDoc = (clientDoc,key) => {
        if (confirm(t('really_remove'))) {
            dispatch(clientDocsActions.deleteClientDoc(
                {
                    token: Biscuit.get('token'),
                    id: clientDoc.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setDeleteClientDocPending(key);
        }
    }

    const getClientDoc = (clientDoc,key) => {
        props.dispatch(s3Actions.getDocumentS3({
            client_id: 3,
            type: 'UserDoc',
            location: 0,
            environment: 'live',
            name: clientDoc.file,
            apiEntryPoint: getApiHost(),
            token: Biscuit.get('token')
        }));
        setGetDocumentPending(clientDoc.file);
    }

    const publish = (clientDoc,key) => {
        dispatch(clientDocsActions.publishDoc(
            {
                token: Biscuit.get('token'),
                id: clientDoc.id,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }
        ));
        setPublishDocPending(key);
    }

    return (
        <>
            <div className='inb-c-listing off-canvas-content' id="inb-c-main-orders" style={{ minHeight: "1150px" }}>
                {localClientDocs.map((clientDoc,index) => {
                    return (
                        <>
                        <div className={"inb-c-item inb-c-item--order row"} style={{padding:'0px'}} key={clientDoc.id}>
                            <div className="inb-c-item row" style={{width: '100%',marginRight: '0px',padding: '0px',border: '0'}}>
                                <div className="medium-3 small-2 column inb-order-big" title={t('id')}>{clientDoc.id}</div>
                                <div className="medium-6 small-6 column inb-order-big" title={t('description')}>{clientDoc.description}</div>
                                <div className="medium-2 small-6 medium-offset-0 column item-button-group">


                                <div className="button-container left">
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={ t('document') }>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => getClientDoc(clientDoc,index)}>
                                            <div className="fi fi-page"></div>
                                        </button>
                                    </a>
                                </div>
                                    <div className="button-container">
                                        <a
                                            href={"/client_docs/"+clientDoc.id}
                                            title=""
                                            data-inb-action-link="edit">
                                            <button type="button" className="inb-round-btn hollow round float-left">
                                                <div className="inb-fi-edit"></div>
                                            </button>
                                        </a>
                                    </div>

                                        {!deleteClientDocPending ?
                                    <div className="button-container">
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={ t('delete') }>
                                            <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => deleteClientDoc(clientDoc,index)}>
                                                <div className="inb-fi-remove"></div>
                                            </button>
                                        </a>
                                    </div>:<span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span> }


                                <div className="button-container">
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={ t('publish') }>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => publish(clientDoc,index)}>
                                            <div className="fi fi-page-add"></div>
                                        </button>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                        </>);
                })}
            </div>
    </>
    );
}
export default ClientDocsList;